module.exports = __webpack_public_path__ + "static/howtorelax-b90919f451b86978a1e41b21e8b0fea0.gif";